<nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton" class="search-inputs">
	<input
		id="search-input" type="text" nz-input placeholder="{{ 'topBar.typeToSearch' | translate }}"
		[ngModel]="searchText" (ngModelChange)="livesearch($event)" (keydown.enter)="doSearch()"
		#autofocused
	/>
</nz-input-group>
<ng-template #suffixIconButton>
	<button nz-button nzType="primary" nzSearch (click)="doSearch()"><i nz-icon nzType="search"></i></button>
</ng-template>
<nz-input-group *ngIf="!protectedPrivacy" class="extended-search">
	<label (ngModelChange)="toggleExtendedSearch()" [ngModel]="useExtendedSearch" nz-checkbox>{{ 'search.use_extended_search' | translate}}</label>
</nz-input-group>
